import { staticPageStyles } from '@aboutyou/legacy-shared'
import { inject } from 'helpers/mobx'
import React from 'react'
import styled from 'styled-components'

interface ITextProps {
  htmlContent: string
  title: string
}

const Text = styled.div`
  ${staticPageStyles}
`

const CampaignText: React.FunctionComponent<ITextProps> = ({
  htmlContent,
  title,
}) => {
  return (
    <Text>
      <h1>{title}</h1>
      <div className={'static-content__text-padding'}>
        <p dangerouslySetInnerHTML={{ __html: htmlContent }} />
      </div>
    </Text>
  )
}

export default inject(store => ({
  title: store.t('Aktionsbedingungen'),
  htmlContent: store.campaignStore.conditions,
}))(CampaignText)
